/**
 * Southern Cross “Visiting New Zealand” policy type codes.
 * Used where VISIT-NZ flow swaps wizard steps (e.g. Cash/Bank Cards vs Baggage).
 */
export const SCTI_VISITING_NEW_ZEALAND_POLICY_TYPES = [
  'VISIT-NZ',
  'VISIT-NZ-WLP001',
];



// WEBPACK FOOTER //
// ./app/containers/FastCover/constants/policyTypes.js